import React from 'react';
import ReactSlider from 'react-slider';

import { ANYTIME_TEXT } from '@stencil/flights-constants/src/text';
import * as S from './travel-date-widget.styles';

const TravelDateWiget = ({
  handleTravelDateVisible,
  isAnyTimeSelected,
  isSelectedMonth,
  isTravelDateWidgetVisible,
  handleTravelDateAnyTime,
  travelDates,
  travelDate,
  handleTravelDateMonth,
  journeyType,
  tripDuration,
  handleTripDuration,
  travelDateRef
}) => {
  return (
    <S.IbiboMf>
      <div className="searchWidget">
        <label>TRAVEL DATES</label>
        <input
          onClick={handleTravelDateVisible}
          className="travellDateInput"
          value={isAnyTimeSelected ? ANYTIME_TEXT : travelDate?.monthToDisplay}
          type="text"
        />
        {isTravelDateWidgetVisible && (
          <div className="travellDatedMF" ref={travelDateRef}>
            <p
              className={
                'travellDateTag fullWidth ' + (isAnyTimeSelected ? 'travelDateSelected' : '')
              }
              onClick={handleTravelDateAnyTime}
            >
              {ANYTIME_TEXT}
            </p>
            <div>
              {travelDates.map(item => {
                return (
                  <span
                    onClick={() => handleTravelDateMonth(item)}
                    className={
                      'travellDateTag ' +
                      (isSelectedMonth === item && !isAnyTimeSelected ? 'travelDateSelected' : '')
                    }
                    key={item}
                  >
                    {item}
                  </span>
                );
              })}
              {journeyType === 'rt' ? (
                <S.TripSlider>
                  <p className="f500 marginB30">TRIP DURATION</p>
                  <div className="durationRangeOuter">
                    <ReactSlider
                      className="fltSld-target"
                      thumbClassName="fltSld-handle"
                      trackClassName="fltSld-connect"
                      defaultValue={[tripDuration]}
                      min={1}
                      max={30}
                      renderThumb={(props, state) => <div {...props}>{state.valueNow} days</div>}
                      onAfterChange={handleTripDuration}
                    />
                    <p className="dF justifyBetween greyCnt f500 marginT15">
                      <span>1 Day</span>
                      <span>30 Day</span>
                    </p>
                  </div>
                </S.TripSlider>
              ) : null}
            </div>
          </div>
        )}
      </div>
    </S.IbiboMf>
  );
};

export default TravelDateWiget;
